import { FC } from "react"

import { css } from "@emotion/react"

import {
	DeviceStatusCategory,
	GenericDeviceStatus,
	getGenericDeviceStatus,
	VacutechStatus,
} from "@ncs/ncs-api"

import { StatusBlip } from "./StatusBlip"

export interface StatusBlipLineProps {
	statuses: (DeviceStatusCategory | VacutechStatus)[]
}

export const StatusBlipLine: FC<StatusBlipLineProps> = ({ statuses }) => {
	return (
		<div css={lineStyle}>
			{statuses
				.filter((s) => getGenericDeviceStatus(s) === GenericDeviceStatus.Normal)
				.map((s, i) => (
					<StatusBlip key={i} status={s} css={blipStyle} />
				))}
			{statuses
				.filter((s) => getGenericDeviceStatus(s) === GenericDeviceStatus.Warning)
				.map((s, i) => (
					<StatusBlip key={i} status={s} css={blipStyle} />
				))}
			{statuses
				.filter((s) => getGenericDeviceStatus(s) === GenericDeviceStatus.Unknown)
				.map((s, i) => (
					<StatusBlip key={i} status={s} css={blipStyle} />
				))}
			{statuses
				.filter((s) => getGenericDeviceStatus(s) === GenericDeviceStatus.Error)
				.map((s, i) => (
					<StatusBlip key={i} status={s} css={blipStyle} />
				))}
		</div>
	)
}

const lineStyle = css`
	display: flex;
	flex-wrap: wrap;
	// To get the blips stacking properly, we need to do some weird magic stuff.
	direction: rtl;
	justify-content: flex-end;
`
const blipStyle = css`
	margin-left: -2px;
`
